var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNachkontrolleImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 480",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Card4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "50%",
    x2: "50%",
    y2: "93.187%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4FD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 480,
    display: "none",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.75 268.8) rotate(180) translate(-374.15 -182.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    transform: "translate(374.15 182.4) rotate(180) translate(-374.15 -182.4)",
    d: "m748.31 364.8c0-255.72-118.44-364.8-374.15-364.8s-374.15 109.08-374.15 364.8h748.31z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 694.31,
    cy: 169.2,
    r: 10.8,
    fill: "#E5EEFF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    transform: "translate(657.11 278.4) rotate(150) translate(-657.11 -278.4)",
    d: "m648.46 281.27c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.415-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#C4D2ED",
    opacity: 0.42593
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.71,
    cy: 69.6,
    r: 14.4,
    fill: "#F3F6FD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.11,
    cy: 72.918,
    r: 6,
    fill: "#D7DBE7"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(145.91 319.2) rotate(163) translate(-145.91 -319.2)",
    d: "m140.37 321.53c-1.9825-6.3548 6.1953-11.464 10.284-5.7318 3.7172 5.2334-2.4781 11.339-7.8061 8.5977-2.1064-1.1214-3.965 2.1183-1.8586 3.2397 9.0451 4.735 18.958-5.981 12.391-14.33-6.6909-8.5977-19.701-0.87223-16.603 9.2207 0.74344 2.2429 4.3367 1.3706 3.5933-0.99684z",
    fill: "#C7D5EE",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(93.399 238.38) rotate(-15) translate(-93.399 -238.38)",
    d: "m83.708 242.46c-3.4694-11.121 10.842-20.061 17.997-10.031 6.5051 9.1584-4.3367 19.843-13.661 15.046-3.6862-1.9625-6.9387 3.707-3.2525 5.6695 15.829 8.2862 33.176-10.467 21.684-25.077-11.709-15.046-34.477-1.5264-29.056 16.136 1.301 3.925 7.5892 2.3986 6.2882-1.7445z",
    fill: "#E7EEF9",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(652.31 76.8) rotate(30) translate(-652.31 -76.8)",
    d: "m643.66 79.673c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.415-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#F4F7FE"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(205 101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "brave-community",
    transform: "translate(-0)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "community-l-link",
    transform: "translate(-0)",
    fill: "#fff",
    stroke: "#5374A5",
    strokeWidth: 7.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "community-l",
    d: "m-7.1054e-13 6.6556c0-3.6758 3.6603-6.6556 8.2168-6.6556h304.57c4.538 0 8.2168 2.9678 8.2168 6.6556v265.69c0 3.6758-3.6603 6.6556-8.2168 6.6556h-304.57c-4.538 0-8.2168-2.9678-8.2168-6.6556v-265.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.17 12.509)",
    fill: "#5374A5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.9383,
    cy: 4.9241,
    rx: 4.9383,
    ry: 4.9241
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.399,
    cy: 4.9241,
    rx: 4.9383,
    ry: 4.9241
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.863,
    cy: 4.9241,
    rx: 4.9383,
    ry: 4.9241
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Nachkontrolle_img",
    transform: "translate(49.2 72.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_accept_request_vdsd",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.22,
    cy: 17.945,
    rx: 10.403,
    ry: 10.431,
    stroke: "#C7D5EE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.12 2.9379-2.5152-2.5352c-0.24898-0.25524-0.58932-0.40019-0.94538-0.40269-0.35606-0.0024345-0.69836 0.13779-0.95084 0.38956l-15.789 15.699-6.6762-6.7471c-0.24792-0.25221-0.58562-0.3953-0.93878-0.39778-0.35316-0.002479-0.69283 0.13586-0.94425 0.38456l-2.5414 2.522c-0.5238 0.52286-0.52968 1.3712-0.013182 1.9014l10.139 10.246c0.52145 0.52521 1.3675 0.53111 1.8962 0.013214l19.265-19.172c0.25454-0.24966 0.3991-0.59091 0.40161-0.94793 0.00244-0.35702-0.13738-0.70025-0.38844-0.95343z",
    fill: "#5374A5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C7D5EE",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.22,
    cy: 55.496,
    rx: 10.403,
    ry: 10.431
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.22,
    cy: 93.047,
    rx: 10.403,
    ry: 10.431
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.22,
    cy: 136.6,
    rx: 10.403,
    ry: 10.431
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#5374A5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m223.12 40.837-2.5152-2.5352c-0.24898-0.25524-0.58932-0.40019-0.94538-0.40269-0.35606-0.0024345-0.69836 0.13779-0.95084 0.38956l-15.789 15.699-6.6762-6.7471c-0.24792-0.25221-0.58562-0.3953-0.93878-0.39778-0.35316-0.002479-0.69283 0.13586-0.94425 0.38456l-2.5414 2.522c-0.5238 0.52286-0.52968 1.3712-0.013182 1.9014l10.139 10.246c0.52145 0.52521 1.3675 0.53111 1.8962 0.013214l19.265-19.172c0.25454-0.24966 0.3991-0.59091 0.40161-0.94793 0.00244-0.35702-0.13738-0.70025-0.38844-0.95343z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.12 122.63-2.5152-2.5352c-0.24898-0.25524-0.58932-0.40019-0.94538-0.40269-0.35606-0.002435-0.69836 0.13779-0.95084 0.38956l-15.789 15.699-6.6762-6.7471c-0.24792-0.25221-0.58562-0.3953-0.93878-0.39778-0.35316-0.002479-0.69283 0.13586-0.94425 0.38456l-2.5414 2.522c-0.5238 0.52286-0.52968 1.3712-0.013182 1.9014l10.139 10.246c0.52145 0.52521 1.3675 0.53111 1.8962 0.013218l19.265-19.172c0.25453-0.24966 0.39909-0.5909 0.4016-0.94792 0.002441-0.35702-0.13738-0.70024-0.38843-0.95342z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    y: 12.403,
    width: 160,
    height: 10,
    rx: 4.8
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 89.203)",
    fill: "#79A3FF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175.2,
    height: 9.6,
    rx: 4.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 50.803)",
    fill: "#5374A5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.6,
    height: 9.6,
    rx: 4.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 127.6)",
    fill: "#5374A5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158.4,
    height: 9.6,
    rx: 4.8
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNachkontrolleImg);
export default __webpack_public_path__ + "static/media/Nachkontrolle_img.3a9c55474f6ed4c227ae9cdf13511c8f.svg";
export { ForwardRef as ReactComponent };